module.exports = __webpack_public_path__ + "static/img/12.bf38ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/en/12.jpg
// module id = Z7vD
// module chunks = 2